import React, { Component } from 'react';
import { withTranslation, Translation, } from 'react-i18next';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import { View, ActivityIndicator} from "react-native-web";

/*import HeaderPC from '../../header/HeaderPC';
import HeaderMobile from '../../header/HeaderMobile';
import HeaderTablet from '../../header/HeaderTablet';*/

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function MyLoadingComponent() {




    return (

	         <div>


                  {!isMobileOnly && !isTablet &&
                    <BrowserView>
                      <View style={{width: viewportWidth*0.6+'px', height: (viewportHeight-30)+'px', justifyContent: 'center',alignSelf: 'center', backgroundColor: '#181f2a', overflowY: 'auto', borderRadius: '8px',}}>


                        <View><ActivityIndicator  animating={true} color="#8996a6" /></View>

                          <View><div style={{clear:'both', height: '50px'}}></div></View>

                          <View><div style={{width: '300px', margin: 'auto', textAlign: 'center'}}><img src={'https://d3van47cb9u9tj.cloudfront.net/rerdc/reRDC_logo.png'} style={{width: '300px'}}/></div></View>


                      </View>
                   </BrowserView>
                 }



                 {isMobileOnly &&
           			  <MobileView>
                    <View style={{width: viewportWidth*0.9+'px', height: viewportHeight*0.8+'px', justifyContent: 'center',alignSelf: 'center', backgroundColor: '#181f2a', overflowY: 'auto', borderRadius: '8px',}}>




                      <View><ActivityIndicator  animating={true} color="#8996a6" /></View>

                        <View><div style={{clear:'both', height: '50px'}}></div></View>

                        <View><div style={{width: '50%', margin: 'auto', textAlign: 'center'}}><img src={'https://d3van47cb9u9tj.cloudfront.net/rerdc/reRDC_logo.png'} style={{width: '100%'}}/></div></View>



                    </View>
           			 </MobileView>
           			}

           			{isTablet &&
           			  <TabletView>
                  <View style={{width: Math.max(viewportWidth*0.8, 600)+'px', height: viewportHeight*0.8+'px', justifyContent: 'center',alignSelf: 'center', backgroundColor: '#181f2a', overflowY: 'auto', borderRadius: '8px',}}>




                        <View><ActivityIndicator  animating={true} color="#8996a6" /></View>

                          <View><div style={{clear:'both', height: '50px'}}></div></View>

                          <View><div style={{width: '300px', margin: 'auto', textAlign: 'center'}}><img src={'https://d3van47cb9u9tj.cloudfront.net/rerdc/reRDC_logo.png'} style={{width: '300px'}}/></div></View>



                      </View>
           			  </TabletView>
           			}








	        </div>

    )

}
